import { Component, Input, OnInit } from "@angular/core";
import { TimeScanningService } from "../../shared/data.service";

@Component({
	selector: "caass-scan-point-manual-schedule",
	templateUrl: "./scan-point-manual-schedule.component.html",
	styleUrls: ["./scan-point-manual-schedule.component.css"],
})
export class ScanPointManualScheduleComponent implements OnInit {
	constructor(private scanService: TimeScanningService) {}

	ngOnInit(): void {
		this.loadDayOptions();
		this.loadScheduleData();
	}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////
	AudienceMode: any = "Student";
	@Input() FacilityID: any;
	@Input() SelectedPerson: any;
	/////////////////////////////////////////////////////////////////

	lstSchedule: any = [];
	SelectedEntry: any = null;

	cols = [
		{ field: "CourseDesc", header: "Course" },
		{ field: "RoomNo", header: "Room" },
		{ field: "Instructor", header: "Instructor" },
		{ field: "Section", header: "Section" },
		{ field: "Period", header: "Period" },
		{ field: "Day", header: "Day" },
		{ field: "Semester", header: "Semester" },
		{ field: "StartTime", header: "Start Time" },
	];

	pagefirst: Number = 0;
	pagerows: Number = 5;

	DayOption: any = 0;
	lstDayOptions: any = [];

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////
	loadDayOptions() {
		if (this.SelectedPerson == null || this.SelectedPerson.PersonID <= 0) {
			return;
		}

		var result = this.scanService.DayOptionSelectList("", this.SelectedPerson.PersonID); ///////
		result.subscribe(
			(response) => {
				this.lstDayOptions = response;
			},
			(error) => {}
		);
	}

	loadScheduleData() {
		if (this.SelectedPerson == null || this.SelectedPerson.PersonID <= 0) {
			return;
		}

		var result = this.scanService.ScheduleInfoGetList("", this.SelectedPerson.PersonID, this.DayOption); ///////
		result.subscribe(
			(response) => {
				this.lstSchedule = response;
			},
			(error) => {}
		);
	}
	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}

	onDayChange(val) {
		this.DayOption = val;

		this.loadScheduleData();
	}
	/////////////////////////////////////////////////////////////////
}
